import { defineMessages } from 'react-intl';

export default defineMessages({
  defaultPlaceholder: {
    id: 'sku-rules-block.default-placeholder',
    defaultMessage: 'Select default option',
  },
  defaultToggle: {
    id: 'sku-rules-block.default-toggle',
    defaultMessage: 'Set default option',
  },
  maxSelectionLabel: {
    id: 'sku-rules-block.max-selection-label',
    defaultMessage: 'Maximum selection',
  },
  minSelectionLabel: {
    id: 'sku-rules-block.min-selection-label',
    defaultMessage: 'Minimum selection',
  },
  multipleToggle: {
    id: 'sku-rules-block.multiple-toggle',
    defaultMessage: 'Customers can select multiple options',
  },
  noneOption: {
    id: 'sku-rules-block.none-option',
    defaultMessage: 'None',
  },
  quantitiesToggle: {
    id: 'sku-rules-block.quantities-toggle',
    defaultMessage: 'Customers can select a single option more than once',
  },
  requiredToggle: {
    id: 'sku-rules-block.required-toggle',
    defaultMessage: 'Make modifier selection required',
  },
  title: {
    id: 'sku-rules-block.title',
    defaultMessage: 'Rules',
  },
});
